// src/pages/ShopsPage.js
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { firestore } from "../firebase";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Default shop image in case the shop doesn't have an image.
const DEFAULT_SHOP_IMAGE = "https://via.placeholder.com/300?text=No+Image";

const ShopsPage = () => {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchShops = async () => {
      try {
        const shopsSnapshot = await getDocs(
          collection(firestore, "rentalShops")
        );
        const shopsList = shopsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setShops(shopsList);
      } catch (error) {
        console.error("Error fetching shops:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchShops();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header />
        <Container sx={{ mt: 4, mb: 4, flexGrow: 1 }}>
          <Typography variant="h4" align="left" gutterBottom>
            Rental Shops
          </Typography>
          {loading ? (
            <CircularProgress sx={{ display: "block", margin: "20px auto" }} />
          ) : (
            <Grid container spacing={3}>
              {shops.length === 0 ? (
                <Typography variant="h6" align="center">
                  No shops available.
                </Typography>
              ) : (
                shops.map((shop) => (
                  <Grid item xs={12} sm={6} md={4} key={shop.id}>
                    <Card>
                      <CardMedia
                        component="img"
                        height="200"
                        image={shop.imageUrl || DEFAULT_SHOP_IMAGE}
                        alt={shop.name}
                      />
                      <CardContent>
                        <Typography variant="h6" gutterBottom>
                          {shop.name}
                        </Typography>
                        <Button
                          variant="contained"
                          fullWidth
                          onClick={() => navigate(`/shop/${shop.id}`)}
                        >
                          View Details
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              )}
            </Grid>
          )}
        </Container>
        <Footer />
      </Box>
    </>
  );
};

export default ShopsPage;
